import { render, staticRenderFns } from "./single-sales-profile.vue?vue&type=template&id=7480dc3d&scoped=true"
import script from "./single-sales-profile.vue?vue&type=script&lang=js"
export * from "./single-sales-profile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7480dc3d",
  null
  
)

export default component.exports